<template>
  <section
    class="tutorial"
    :class="isMobile ? 'mobile-overlay' : ''"
  >
    <tutorial-tasks
      :tasks="tasks"
    />
    <tutorial-overlay
      v-if="
        tutorialState.anne.showAnne || tutorialState.tutorialMessage.showMessage
      "
      style="pointer-events: auto"
      @click.prevent=""
      @mousedown.prevent=""
      @mouseup.prevent=""
      @touchstart.prevent=""
      @touchend.prevent=""
    />
    <tutorial-anne
      v-if="tutorialState.anne.showAnne"
      :is-right="tutorialState.anne.isRight"
    />
    <tutorial-under-menu v-if="tutorialState.showUnderMenu" />
    <tutorial-message-box
      v-if="tutorialState.tutorialMessage.showMessage"
      :key="tutorialCoreState.typeWriter"
      :type-write="tutorialCoreState.typeWriter"
      :class="{ offsetBot: tutorialState.tutorialMessage.offset }"
      :header-text="$t('anne')"
      :text="$t(tutorialState.tutorialMessage.message)"
      :color="tutorialState.tutorialMessage.color"
      :button-yellow-text="tutorialState.tutorialMessage.yellowText"
      :force-hide-white-text="tutorialState.tutorialMessage.yellowTextSpecial"
      @show-full-text="setTypewriteToInactive"
    />
    <tutorial-hand-settings
      v-if="tutorialState.mobile.show"
      style="pointer-events: auto"
      :img-url="`https://appspowerplaymanager.vshcdn.net/images/
        winter-sports/minigame/cross-country/ui/tutorial/MOBIL_BM.png`"
      @mousedown.stop=""
      @mouseup.stop=""
      @touchstart.stop=""
      @touchend.stop=""
      @click-continue="continueTask"
    >
      <div class="mobiler">
        <div class="buttons">
          <div
            class="button-group"
            :class="{ reverse: !gameSettingsState.isLeft }"
          >
            <img
              width="150"
              height="200"
              :src="`${pathAssets}/ui/tutorial/button_biatlon_action.png`"
              alt="button1"
            >
            <img
              width="150"
              height="150"
              :src="`${pathAssets}/ui/tutorial/button_biatlon_movement.png`"
              alt="button2"
            >
          </div>
        </div>
      </div>
    </tutorial-hand-settings>
    <tutorial-button-start
      v-if="tutorialState.showButtonStart && isMobile"
      :is-mobile-forced="isMobile"
    />
    <tutorial-buttons />
    <tutorial-bars v-if="!isMobile" />
  </section>
</template>

<script lang="ts">
import {
  TutorialAnne,
  TutorialMessageBox,
  TutorialTasks,
  TutorialOverlay,
  TutorialHandSettings,
  tutorialCoreState,
  gameSettingsState,
  type GameSettingsState,
  type TutorialCoreState
} from '@powerplay/core-minigames-ui'
import {
  settings,
  tutorialManager
} from '@powerplay/core-minigames'
import type { TutorialObjective } from '@powerplay/core-minigames'
import TutorialButtonStart from '@/components/Tutorial/TutorialButtonStart.vue'
import TutorialButtons from '@/components/Tutorial/TutorialButtons.vue'
import TutorialBars from '@/components/Tutorial/TutorialBars.vue'
import TutorialUnderMenu from '@/components/Tutorial/TutorialUnderMenu.vue'
import { pathAssets } from '@/globals/globalvariables'
import { TutorialObjectiveIds } from '@/app/types'

import { defineComponent } from 'vue'
import {
  tutorialState,
  type TutorialState
} from '@/stores'

interface BasicComponentData {
  tasks: { color: string, text: string}[],
  pathAssets: string,
  tutorialState: TutorialState,
  gameSettingsState: GameSettingsState,
  tutorialCoreState: TutorialCoreState,
}

export default defineComponent({
  name: 'TutorialLogicComponent',
  components: {
    TutorialAnne,
    TutorialMessageBox,
    TutorialTasks,
    TutorialOverlay,
    TutorialHandSettings,
    TutorialButtonStart,
    TutorialButtons,
    TutorialUnderMenu,
    TutorialBars
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  data(): BasicComponentData {

    return {
      tasks: [],
      pathAssets,
      tutorialState: tutorialState(),
      gameSettingsState: gameSettingsState(),
      tutorialCoreState: tutorialCoreState(),
    }

  },
  computed: {
    basicStyle() {

      return {
        'align-items': 'flex-end',
        width: '290px',
        height: '200px',
        padding: '20px'
      }

    }
  },

  watch: {
    tutorialState: {
      immediate: true,
      deep: true,
      handler() {

        this.updateTasks()

      }
    }
  },
  methods: {
    setTypewriteToInactive() {

      tutorialCoreState().typeWriter = false
      tutorialManager.setTypeWriting(false)

    },
    continueTask() {

      this.setThings()
      settings.saveValues()
      window.dispatchEvent(new Event('mousedown'))

    },
    setThings(): void {

      settings.update('quality', gameSettingsState().graphicsSettings)
      settings.update('sounds', gameSettingsState().volume ? 1 : 0)
      settings.update('qualityAuto', gameSettingsState().graphicsAuto ? 1 : 0)
      settings.update('isLeft', gameSettingsState().isLeft ? 1 : 0)

    },
    updateTasks() {

      this.tasks = tutorialState().objectives.map((objective: TutorialObjective) => {

        let color = 'blue'
        let name = this.$t(objective.name)

        if (objective.name === TutorialObjectiveIds.slipStream) {

          name = this.$t(objective.name).replace(
            '[number]',
            `${tutorialState().slipStreamSeconds}/5`
          )

        }
        if (objective.passed) color = 'green'
        if (objective.failed) color = 'red'
        return {
          color,
          text: name
        }

      })

    }
  },
})
</script>

<style lang="less">
.tutorial {

    &.mobile-overlay {
      .tutorial-anne, .tutorial-mobil, .tutorial-hand-bottom {
          position: fixed;
      }
    }

  .offsetBot {
    bottom: 40%;
  }

  .tutorial-tasks {
    position: absolute;
    left: 1%;
    top: 17%;
  }
}
.mobiler {
    height: 100%;

    .buttons {
        position: relative;
        width: 100%;
        height: 100%;

        .button-group {
            position: absolute;
            bottom: 130px;
            left: 130px;
            right: 130px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.reverse {
                flex-direction: row-reverse;
            }
        }
    }
}
</style>
